var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-list-item',{staticClass:"ripple",staticStyle:{"overflow":"hidden"},attrs:{"title":_vm.question.title + _vm.question.option.toString()},on:{"click":function($event){$event.stopPropagation();return _vm.toggleSwitch.apply(null, arguments)}}},[_c('font-awesome-icon',{staticStyle:{"color":"#FFFFFF","border-radius":"2px"},style:({
      border: _vm.question.value ? 'none' : 'solid 1px #888888',
      background: _vm.question.value ? '#4CAF50' : '#FFFFFF',
      padding: _vm.question.value ? '2px' : '1px'
    }),attrs:{"slot":"after","icon":"check"},slot:"after"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }